var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      "enableBackground": "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8,2.1C60.3,0.8,58.9,0,57.3,0H6.7C5.4,0,4,0.8,3.2,2.1C2.7,3.2,2.9,4.8,3.7,5.9l17.7,20.4v34.3c0,1.3,0.5,2.4,1.6,2.9 c0.5,0.3,1.3,0.5,1.9,0.5c0.8,0,1.3-0.3,2.1-0.5L41,54.6l0.5-0.3c1.1-1.1,1.3-2.1,1.3-2.7V26L60.3,5.9C61.1,5.1,61.3,3.5,60.8,2.1z M38.6,23c-1.1,1.1-1.1,2.1-1.1,2.7v25.2l-10.7,6.7V25.7c0-0.8-0.3-1.6-0.8-2.4L10.4,5.4h43.4L38.6,23z"
  })));
};
export default __webpack_public_path__ + "static/media/funnel.0ef52437.svg";
export { SvgComponent as ReactComponent };